import { Formik, FormikActions, FormikProps } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';
import { RouteComponentProps, Redirect } from 'react-router';

import API from 'src/services/api';
import { FormInput, Button } from 'src/components';
import { toast } from 'react-toastify';

interface ILocationParams {
  email: string;
  code: string;
}
interface IFormFields {
  code: string;
  password: string;
}
interface IPasswordChangeState {
  error: string;
  success: boolean;
}

export default class PasswordChange extends React.Component<
  RouteComponentProps<ILocationParams>,
  IPasswordChangeState
> {
  state: IPasswordChangeState = {
    error: '',
    success: false,
  };

  schema = Yup.object().shape({
    password: Yup.string()
      .min(8)
      .matches(
        /^(?=.*[a-zA-Z0-9])(?=.*[!?@#$%^&*()+\-=\[\];',/\\{}<>`~_\.])[^\s]*$/
      )
      .required('Required'),
  });

  initialValues: IFormFields = { password: '', code: '' };

  onSubmit = async (
    values: IFormFields,
    actions: FormikActions<IFormFields>
  ) => {
    this.setState({ error: '' });
    try {
      const { email, code } = this.props.match.params;
      await API.USER.PASSWORD_CHANGE.reset({
        email: decodeURIComponent(email),
        code: decodeURIComponent(code || values.code),
        password: values.password,
      });
      this.setState({ success: true });
    } catch (error) {
      const message = error.response.data.errorMessage;
      this.setState({
        error: message === 'invalid_user' ? 'Invalid user' : message,
      });
    }
    actions.setSubmitting(false);
  };

  formRender = ({
    errors,
    handleSubmit,
    isSubmitting,
  }: FormikProps<IFormFields>) => {
    const hasCode = Boolean(this.props.match.params.code);
    return (
      <form onSubmit={handleSubmit}>
        {!hasCode && (
          <div className="flex items-center mt-6 mb-4">
            <label className="w-48 text-right pr-6" htmlFor="code">
              Recovery code
            </label>
            <FormInput
              className="flex-1"
              type="text"
              name="code"
              secondary={true}
            />
          </div>
        )}
        <div className="flex items-center mt-6 mb-4">
          <label className="w-48 text-right pr-6" htmlFor="username">
            New password
          </label>
          <FormInput
            className="flex-1"
            type="password"
            name="password"
            autoFocus={true}
            secondary={true}
          />
        </div>
        <p
          className={`ml-48 mb-6 text-sm ${errors.password ? 'text-red' : ''}`}
        >
          Please use a password at least 8 characters long and with at least one
          character that is not a letter or number, such as <code>!&%</code> and
          no spaces
        </p>
        <div className="flex items-center ml-48">
          <Button type="submit" loading={isSubmitting} loadingLabel="Changing">
            Change
          </Button>
          {this.state.error && (
            <span className="flex-1 ml-4 text-red">{this.state.error}</span>
          )}
        </div>
      </form>
    );
  };

  render() {
    if (this.state.success) {
      toast.success('Password changed, you may now log in');
      return <Redirect to="/login" />;
    }
    return (
      <div className="w-1/2 my-32 mx-auto text-xl">
        <h2 className="ml-48 mb-8">Change password</h2>

        <Formik
          initialValues={this.initialValues}
          validationSchema={this.schema}
          onSubmit={this.onSubmit}
          render={this.formRender}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PasswordChange/PasswordChange.tsx